import BootstrapButton from "@/components/form/BootstrapButton"
import Icon from "@/components/Icon"
import { ContentLoading } from "@/components/loading/StateLoading"
import Modal from "@/components/Modal"
import { useLoggedInUser } from "@/stores/coreDataStore"
import { faFileExport, faFilter } from "@fortawesome/free-solid-svg-icons"
import { css } from "vite-css-in-js"
import { onBeforeMount, ref } from "vue"
import { defineComponent, loadLoadable, RefQueries, useQueryStoreRef, type ReactiveComponent } from "vue-utils"
import BasicPage from "../BasicPage"
import { canCreateVtsLog } from "./permissions"
import { useVtsLogStore } from "./store"
import SearchVtsLogFilters from "./vts-searching/SearchVtsLogFilters"
import { bindVtsLogRequestToQuery } from "./vts-searching/useVtsLogSearch"
import VtsEntryForm from "./VtsEntryForm"
import VtsResultsDisplay from "./VtsResultsDisplay"

const filterStyles = css`
	display: inline-flex;
	flex-wrap: wrap;
	gap: 1rem 1rem;
	margin-bottom: 1rem;

	align-items: end;
	justify-content: stretch;

	& > * {
		flex-basis: 16rem;
	}
`

const VtsLogsPage: ReactiveComponent = () => {
	const store = useVtsLogStore()
	const loggedInUser = useLoggedInUser()

	bindVtsLogRequestToQuery(store.requestOptions)
	useQueryStoreRef("log", store, "editingLogId", RefQueries.NullableInt)

	onBeforeMount(() => void loadLoadable(store.vtsLogsRef))

	return () => (
		<BasicPage title="All VTS Logs" class="flex flex-col">
			{canCreateVtsLog(loggedInUser) && (
				<>
						<VtsEntryForm key={store.creationFormKey} existingVts={null}/>
					<hr />
				</>
			)}
			<div class={filterStyles}>
				<SearchVtsLogFilters />

				<div class="flex-grow-1 flex justify-end gap-2">
					<BootstrapButton color="danger" onClick={store.resetOptions}>
						<Icon icon={faFilter} />
						Reset Filters
					</BootstrapButton>
					<BootstrapButton color="primary" onClick={() => void store.exportVtsLog()}>
						<Icon icon={faFileExport} />
						Export VTS Logs
					</BootstrapButton>
				</div>
			</div>

			{(store.editingLog !== null) && (
				<Modal style={{ width: "74rem" }} class="flex flex-col">
					<VtsEntryForm existingVts={store.editingLog} />
				</Modal>
			)}

			<ContentLoading stores={[store.vtsLogsRef]} />
			{store.hasResults() && <VtsResultsDisplay />}
		</BasicPage>
	)
}

export default defineComponent(VtsLogsPage)
